import { Drawer, Button, Descriptions, Tabs, Collapse, Spin, Table, Tag, Tooltip, Modal, message, Popconfirm } from "antd"
import { MARITAL_STATUS_ENUM, EDUCATION_ENUM, GENDER_ENUM, CUSTOMER_SERVICE_TYPE, DIAGNOSIS_TYPE } from '@/utils/consts'
import { CLINIC_NAME, CLINIC_PHONE, CLINIC_KEY } from '@/utils/consts';
import styles from './index.less'
import DemandList from "./DemandList"
import FollowList from "./FollowList"
import OrderList from "./OrderList"
import ReserveList from "./ReserveList"
import HealthyDoc from './HealthyDoc'
import ModifyList from "./ModifyList"
import Statistics from './Statistics'
import LongShowExcelModal from "@/pages/task/components/LongShowExcelModal"
import EditCustomerCode from '../components/EditCustomerInfoCodeDialog'
import { useState, useEffect } from "react"
import { queryQestionnaire } from '@/services/basicinfo'
import { get as SafeGet, isEmpty } from 'lodash'
import moment from 'moment'
import QRCode from 'qrcode.react'
import axios from 'axios'

const { TabPane } = Tabs
const { Panel } = Collapse
const { CheckableTag } = Tag

const moreMenuData = [
  // {
  //   key: 'demand',
  //   name: '需求评估',
  // },
  {
    key: 'evaluation',
    name: '登记测评',
  },
  {
    key: 'orderReserve',
    name: '预约',
  },
  {
    key: 'order',
    name: '下订单',
  },
  // {
  //   key: 'questionnaire',
  //   name: '问卷',
  // },
  {
    key: 'infoCode',
    name: '来访二维码',
  },
  {
    key: 'follow',
    name: '跟进',
  },
  // {
  //   key: 'delete',
  //   name: '删除',
  // }, {
  //   key: 'message',
  //   name: '发短信',
  // }
]

const PersonalDrawer = ({ user, current, source, loaded, infoInit, loading, reserveStatus, classification, onClose, orderPagination,
  onLoadData, onAction, onEdit, onEditStatus, deleteOrder, cancelOrder, onOrderPageNoChange, statistics, fiveTypeHistory, serviceTeamList = {},
  customerHistoryList, customerHistoryPagination, statisticsPagination, statisticsOnChange, executorList, onTreatmentType, onOpenResult, checkReportDetail, onOpenUrl, onTriggerShared, onTriggerShared2, ...drawerProps }) => {
  const { info = {}, demand, follow, order, reserve, modify, treatment } = current
  const { customerFamilies } = info
  const { currentUser: { nickname: myName } } = user
  const currentRole = localStorage.getItem('fulcrum-ancare-role-code')
  const { consultant = {}, psychologyList = [] } = serviceTeamList
  const [tabsKey, setTabsKey] = useState('info')
  const [treatmentTypes, setTreatmentTypes] = useState('')
  const [qestionnaireUrl, setQestionnaireUrl] = useState(null)
  const [qestionnaireVisible, setQestionnaireVisible] = useState(false)
  const [showCodeModal, setShowCodeModal] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setTabsKey('info')
    }, 300)
  }, [info])

  useEffect(() => {
    if (!isEmpty(info)) {
      onLoadData('treatment', { customerId: info.customerId, phone: info.phone })
    }
  }, [info])

  // 获取二维码
  const fetchQueryQestionnaire = async () => {
    const res = await queryQestionnaire({ orgId: '4028f8bc751ffdc201751ffeeef30000', userId: info.customerId, userName: info.name })
    if (res.code !== 0) return
    setQestionnaireUrl(`http://${res.data}`)
    setQestionnaireVisible(true)
  }

  const handleMenuClick = (current) => {
    if (current.key === 'demand') {
      onAction(current.key, 'add', {
        customerId: info.customerId,
        customerName: info.name,
        complain: info.coreRequirement
      })
    } else if (current.key === 'order') {
      onAction(current.key, 'add', {
        customerId: info.customerId,
        customerName: info.name,
        clinicId: info.clinicId,
        personalDoctorId: info.personalDoctorId || undefined,
        consultantDoctorId: info.consultantDoctorId || undefined
      })
    } else if (current.key === 'questionnaire') {
      fetchQueryQestionnaire()
    } else if (current.key === 'infoCode') {
      setShowCodeModal(true)
    } else if (current.key === 'evaluation') {
      // 登记测评
      let clinicId = window.localStorage.getItem(CLINIC_KEY) // 门店id
      let clinicName = window.localStorage.getItem(CLINIC_NAME) // 门店名
      let clinicPhone = window.localStorage.getItem(CLINIC_PHONE) // 门店手机号
      window.open(`https://ac.mpt.cn/#/auto-login-ac?platform=1&type=assess&clinicId=${clinicId}&orgName=${clinicName}&phone=${clinicPhone}&customerId=${info.customerId}&customerName=${info.name}`, '_blank')
    } else {
      onAction(current.key, 'add', {
        customerId: info.customerId,
        customerName: info.name,
        clinicId: info.clinicId,
      })
    }
  }

  // const menu = (<Menu onClick={(key) => handleMenuClick(key)}>
  //   {moreMenuData.map(_ => <Menu.Item key={_.key}>
  //     {_.name}
  //   </Menu.Item>)}
  // </Menu>)

  const title = (
    <div className={styles.drawerHeader}>
      <div className="userInfo">
        <span style={{ marginRight: 12 }}>{info.name}</span>
        {(info.phone || info.weixinId) && <span style={{ marginRight: 12 }}>/</span>}
        <span style={{ marginRight: 12 }}>{info.phone || info.weixinId}</span>
        {info.coreRequirement && <span style={{ marginRight: 12 }}>/</span>}
        <Tooltip title={info.coreRequirement && info.coreRequirement.length > 15 ? info.coreRequirement : ''}>
          <span>{info.coreRequirement && info.coreRequirement.length > 15 ? info.coreRequirement.substring(0, 15) + '...' : info.coreRequirement}</span>
        </Tooltip>
      </div>
      <div className="operation">
        {moreMenuData.map(it => <Button onClick={() => handleMenuClick(it)}>{it.name}</Button>)}
        <Button type="primary" shape="circle" icon="edit" onClick={() => onEdit(current.info)} />
        {/* <Button shape="circle" icon="swap"></Button> */}
        {/* <Dropdown overlay={menu} placement="bottomRight">
          <Button shape="circle" icon="more"></Button>
        </Dropdown> */}
        <Button shape="circle" icon="close" onClick={() => onClose()} ></Button>
      </div>
    </div>
  )

  const onTabsChange = (key) => {
    setTabsKey(key)
    if (!loaded[key]) {
      setTimeout(() => {
        onLoadData(key,{ customerId: info.customerId, phone: info.phone })
      }, 300)
    }
  }

  const familyColumns = [
    {
      dataIndex: 'name',
      title: '姓名',
      width: 80,
    },
    {
      dataIndex: 'relation',
      title: '关系',
      width: 60,
    },
    {
      dataIndex: 'age',
      title: '年龄',
      width: 60,
    },
    {
      dataIndex: 'occupation',
      title: '职业',
      width: 140,
    },
    {
      dataIndex: 'telephone',
      title: '电话',
      width: 120,
    },
    {
      dataIndex: 'emergency',
      title: '紧急联系人',
      width: 100,
      align: 'center',
      render(text) {
        return text ? '是' : '否'
      }
    }
  ]

  const maritalStatusStr = info.maritalStatus && MARITAL_STATUS_ENUM.some(_ => _.value === info.maritalStatus) ? (MARITAL_STATUS_ENUM.find(_ => _.value === info.maritalStatus) || {}).label : ''
  const educationStr = info.education && EDUCATION_ENUM.some(_ => _.value === info.education) ? (EDUCATION_ENUM.find(_ => _.value === info.education) || {}).label : ''
  const genderStr = info.gender && GENDER_ENUM.some(_ => _.value === info.gender) ? (GENDER_ENUM.find(_ => _.value === info.gender) || {}).label : ''
  // const maritalStatusStr = info.maritalStatus && MARITAL_STATUS_ENUM.some(_ => _.value === info.maritalStatus) ? MARITAL_STATUS_ENUM.filter(_ => _.value === info.maritalStatus)[0].label : ''
  let questionTags = []
  if (info.questionType) {
    questionTags = questionTags.concat(info.questionType.split(','))
  }
  // if(info.otherQuestion) {
  //   questionTags.push(info.otherQuestion)
  // }

  if (customerFamilies && customerFamilies.length) {
    if (customerFamilies.length > 0) {
      const father = customerFamilies[0]
      info.fatherName = father.name
      info.fatherAge = father.age
      info.fatherOccupation = father.occupation
    }
    if (customerFamilies.length > 1) {
      const mother = customerFamilies[1]
      info.motherName = mother.name
      info.motherAge = mother.age
      info.motherOccupation = mother.occupation
      info.motherPhone = mother.telephone
    }
    if (customerFamilies.length > 2) {
      const contact = customerFamilies[2]
      info.contactName = contact.name
      info.relation = contact.relation
      info.contactPhone = contact.telephone
    }
  }

  // 诊疗档案
  // const treatmentColumns = [
  //   {
  //     dataIndex: 'name',
  //     title: '名称',
  //     width: 160,
  //     render: (text) => {
  //       return treatmentTypes === 'first_visit_bps_record_sheet' ? 'BPS首诊记录表' : text
  //     }
  //   },
  //   {
  //     dataIndex: treatmentTypes === 'first_visit_bps_record_sheet' ? 'createdUserName' : 'creatorName',
  //     title: '记录人',
  //     width: 120,
  //   },
  //   {
  //     dataIndex: treatmentTypes === 'first_visit_bps_record_sheet' ? 'createdUserRole' : 'creatorRole',
  //     title: '角色',
  //     render(text) {
  //       return text && text.length && text.slice(1, text.length - 1).replace(',', '、')
  //     }
  //   },
  //   {
  //     dataIndex: 'createdAt',
  //     title: '记录时间',
  //     width: 120,
  //     render(text) {
  //       return text && moment(text).format('YYYY-MM-DD')
  //     }
  //   },
  //   {
  //     dataIndex: 'name',
  //     title: '操作',
  //     width: 80,
  //     render(text, record) {
  //       return <a onClick={() => { if (treatmentTypes === 'first_visit_bps_record_sheet') { handleOpenResult({ ...record, taskableType: 'first_visit_bps_record_sheet' }) } else { handleOpenResult(record) } }}>查看</a>
  //     }
  //   },
  // ]
  // const newTreatmentColumns = [
  //   {
  //     dataIndex: 'docName',
  //     title: '名称'
  //   },
  //   {
  //     dataIndex: 'employeeName',
  //     title: '记录人',
  //     render(text, record) {
  //       const { taskableType } = record
  //       if (taskableType === 'suxin_questionnaire_survey') {
  //         return '素心问卷'
  //       }
  //       return text || '--'
  //     }
  //   },
  //   {
  //     dataIndex: 'position',
  //     title: '岗位'
  //   },
  //   {
  //     dataIndex: 'results',
  //     title: '结果',
  //     render(text, record) {
  //       const data = record.data || {}
  //       return <span>{data.scaleResult || '--'}</span>
  //     }
  //   },
  //   {
  //     dataIndex: 'createdAt',
  //     title: '记录时间'
  //   },
  //   {
  //     dataIndex: 'oprate',
  //     title: '操作',
  //     render(text, record) {
  //       return <div>
  //         <a onClick={() => onOpenResult({ ...record, id: record.taskId })}>查看</a>
  //         {
  //           record.taskableType === 'suxin_questionnaire_survey' ?
  //             <a style={{ marginLeft: 15, color: 'grey' }}>编辑</a> :
  //             <a
  //               style={{ marginLeft: 15 }}
  //               onClick={() => {
  //                 // if (currentRole !== 'ROLE_CLINIC_ADMIN') {
  //                 //   if (myName !== record.employeeName) {
  //                 //     return message.error('对不起，仅执行人或门店管理员可操作')
  //                 //   }
  //                 // }
  //                 return onOpenUrl(record)
  //               }}
  //             >编辑</a>
  //         }
  //         {
  //           ['new_bps_report', 'first_visit_bps_record_sheet', 'period_evaluate_report', 'conclude_report'].includes(record.taskableType) &&
  //           record.data.isShared !== true &&
  //           <a style={{ marginLeft: 15, color: '#07c160' }} onClick={() => onOpenResult({ ...record, id: record.taskId })}>分享</a>
  //         }
  //         {
  //           ['new_bps_report', 'first_visit_bps_record_sheet', 'period_evaluate_report', 'conclude_report'].includes(record.taskableType) &&
  //           record.data.isShared === true &&
  //           <Popconfirm
  //             placement="topRight"
  //             title={`请确认${record.data.isShared ? '撤回' : ''}分享微信小程序`}
  //             onConfirm={() => onTriggerShared({ docId: record.docId, taskableType: record.taskableType, isShared: false })}
  //           >
  //             <a style={{ marginLeft: 15, color: '#ff4d4f' }}>撤回</a>
  //           </Popconfirm>
  //         }
  //         {
  //           record.taskableType === 'suxin_questionnaire_survey' &&
  //           <Popconfirm
  //             placement="topRight"
  //             title={`请确认${record.data.isShared ? '撤回' : ''}分享微信小程序`}
  //             onConfirm={() => onTriggerShared2({ docId: record.docId, isShared: !record.data.isShared })}
  //           >
  //             <a style={{ marginLeft: 15, color: !record.data.isShared ? '#07c160' : '#ff4d4f' }} >{record.data.isShared ? '撤回' : '分享'}</a>
  //           </Popconfirm>
  //         }
  //         {
  //           ['new_bps_report', 'first_visit_bps_record_sheet', 'period_evaluate_report', 'conclude_report', 'suxin_questionnaire_survey'].includes(record.taskableType) &&
  //           (record.data.aliyunUrl ? <a style={{ marginLeft: 15 }} onClick={() => downloadPDF(record)}>下载</a> : <a style={{ marginLeft: 15 }} onClick={() => onOpenResult({ ...record, id: record.taskId })}>下载</a>)
  //         }
  //       </div>
  //     }
  //   },
  // ]

  const generateColumns = (key) => {
    switch (key) {
      case '测评报告':
        return [
          {
            dataIndex: 'examTitle',
            title: '名称',
          },
          {
            dataIndex: 'projectNum',
            title: '测评结果',
            render: (text, record) => {
              return <div>共 {text} 份报告</div>
            },
          },
          {
            dataIndex: 'source',
            title: '来源',
          },
          {
            dataIndex: 'created_at',
            title: '记录时间',
            render: (text, record) => {
              return text && moment(text).format('YYYY-MM-DD')
            },
          },
          {
            dataIndex: 'oprate',
            title: '操作',
            render(text, record) {
              return <div>
                <a onClick={() => checkReportDetail({ ...record})}>查看</a>
                {/* 其他操作 */}
              </div>;
            },
          },
        ];
      default:
        return [
          {
            dataIndex: 'docName',
            title: '名称'
          },
          {
            dataIndex: 'employeeName',
            title: '记录人',
            render(text, record) {
              const { taskableType } = record
              if (taskableType === 'suxin_questionnaire_survey') {
                return '素心问卷'
              }
              return text || '--'
            }
          },
          {
            dataIndex: 'position',
            title: '岗位'
          },
          {
            dataIndex: 'results',
            title: '结果',
            render(text, record) {
              const data = record.data || {}
              return <span>{data.scaleResult || '--'}</span>
            }
          },
          {
            dataIndex: 'createdAt',
            title: '记录时间'
          },
          {
            dataIndex: 'oprate',
            title: '操作',
            render(text, record) {
              return <div>
                <a onClick={() => onOpenResult({ ...record, id: record.taskId })}>查看</a>
                {
                  record.taskableType === 'suxin_questionnaire_survey' ?
                    <a style={{ marginLeft: 15, color: 'grey' }}>编辑</a> :
                    <a
                      style={{ marginLeft: 15 }}
                      onClick={() => {
                        // if (currentRole !== 'ROLE_CLINIC_ADMIN') {
                        //   if (myName !== record.employeeName) {
                        //     return message.error('对不起，仅执行人或门店管理员可操作')
                        //   }
                        // }
                        return onOpenUrl(record)
                      }}
                    >编辑</a>
                }
                {
                  ['new_bps_report', 'first_visit_bps_record_sheet', 'period_evaluate_report', 'conclude_report'].includes(record.taskableType) &&
                  record.data.isShared !== true &&
                  <a style={{ marginLeft: 15, color: '#07c160' }} onClick={() => onOpenResult({ ...record, id: record.taskId })}>分享</a>
                }
                {
                  ['new_bps_report', 'first_visit_bps_record_sheet', 'period_evaluate_report', 'conclude_report'].includes(record.taskableType) &&
                  record.data.isShared === true &&
                  <Popconfirm
                    placement="topRight"
                    title={`请确认${record.data.isShared ? '撤回' : ''}分享微信小程序`}
                    onConfirm={() => onTriggerShared({ docId: record.docId, taskableType: record.taskableType, isShared: false })}
                  >
                    <a style={{ marginLeft: 15, color: '#ff4d4f' }}>撤回</a>
                  </Popconfirm>
                }
                {
                  record.taskableType === 'suxin_questionnaire_survey' &&
                  <Popconfirm
                    placement="topRight"
                    title={`请确认${record.data.isShared ? '撤回' : ''}分享微信小程序`}
                    onConfirm={() => onTriggerShared2({ docId: record.docId, isShared: !record.data.isShared })}
                  >
                    <a style={{ marginLeft: 15, color: !record.data.isShared ? '#07c160' : '#ff4d4f' }} >{record.data.isShared ? '撤回' : '分享'}</a>
                  </Popconfirm>
                }
                {
                  ['new_bps_report', 'first_visit_bps_record_sheet', 'period_evaluate_report', 'conclude_report', 'suxin_questionnaire_survey'].includes(record.taskableType) &&
                  (record.data.aliyunUrl ? <a style={{ marginLeft: 15 }} onClick={() => downloadPDF(record)}>下载</a> : <a style={{ marginLeft: 15 }} onClick={() => onOpenResult({ ...record, id: record.taskId })}>下载</a>)
                }
              </div>
            }
          },
        ];
    }
  };

  // 诊疗档案, 使用时动态获取列
  const newTreatmentColumns = generateColumns(treatmentTypes || SafeGet(fiveTypeHistory, '0.key'));
  

  const downloadPDF = (item) => {
    const data = item.data
    const { scaleName, aliyunUrl } = data
    var x = new XMLHttpRequest()
    x.open("GET", aliyunUrl, true)
    x.responseType = 'blob'
    x.onload = function (e) {
      var url = window.URL.createObjectURL(x.response)
      var a = document.createElement('a')
      a.href = url
      a.download = scaleName
      a.click()
    }
    x.send()
  }

  const handleCheckAleTag = e => {
    setTreatmentTypes(e.value)
    let params = {
      customerId: info.customerId,
      taskableType: e.value
    }
    onTreatmentType(params)
  }

  function arrReverse(arr) {
    var newArr = []
    var b = []
    var c = []
    for (var i = 0; i < arr.length; i++) {
      var c = arr[i]
      var b = newArr.unshift(c)
    }
    return arr = newArr
  }

  const roleShowTreatment = (role, name) => {
    const psychologys = psychologyList.map(i => i.nickname)
    if (role !== 'ROLE_CONSULTANT') {
      return true
    }
    if (role === 'ROLE_CONSULTANT' && name === consultant.nickname) {
      return true
    }
    if (role === 'ROLE_CONSULTANT' && psychologys.includes(name)) {
      return true
    }
    return false
  }

  return (
    <Drawer {...drawerProps}
      onClose={onClose}
      title={title}
      onClick={(e) => { e.stopPropagation() }}
    >
      <Tabs className={styles.tabs} activeKey={tabsKey} onTabClick={(key) => onTabsChange(key)}>
        <TabPane tab="基本信息" key="info">
          <Spin spinning={!!loading.effects['personalPotentialList/queryInfo']}>
            <Collapse bordered={false} defaultActiveKey={['1', '2', '4']} expandIconPosition="right">
              <Panel header="基本信息" key="1">
                {info && <Descriptions>
                  <Descriptions.Item label="姓名">{info.name}</Descriptions.Item>
                  <Descriptions.Item label="性别">{genderStr}</Descriptions.Item>
                  <Descriptions.Item label="电话">{info.phone}</Descriptions.Item>
                  <Descriptions.Item label="微信">{info.weixinId}</Descriptions.Item>
                  <Descriptions.Item label="身高">{info.height} cm</Descriptions.Item>
                  <Descriptions.Item label="体重">{info.weight} kg</Descriptions.Item>
                  <Descriptions.Item label="婚姻状况">{maritalStatusStr}</Descriptions.Item>
                  <Descriptions.Item label="年龄">{info.age}</Descriptions.Item>
                  <Descriptions.Item label="生日">{info.birthday}</Descriptions.Item>
                  <Descriptions.Item label="学历">{educationStr}</Descriptions.Item>
                  <Descriptions.Item label="居住城市">{info.address}</Descriptions.Item>
                  <Descriptions.Item label="职业">{info.occupation}</Descriptions.Item>
                  <Descriptions.Item label="客户级别">{info.classification && classification && (classification.find(_ => _.value === info.classification) || {}).key}</Descriptions.Item>
                  <Descriptions.Item label="一级渠道">{info.firstChannelName}</Descriptions.Item>
                  <Descriptions.Item label="二级渠道">{info.secondChannelName}</Descriptions.Item>
                  <Descriptions.Item label="预约习惯">{info.appointmentHabit}</Descriptions.Item>
                  <Descriptions.Item label="首/复诊">{info.treatmentStatus && (DIAGNOSIS_TYPE.find(_ => _.value === info.treatmentStatus) || {}).label}</Descriptions.Item>
                  <Descriptions.Item label="从哪了解安肯并预约">{info.knowWay}</Descriptions.Item>
                  <Descriptions.Item label="之前是否做过心理咨询">{info.hadCounseling ? '是' : '否'} {info.timeInstitution}</Descriptions.Item>
                  <Descriptions.Item label="居住地址">{info.liveAddress}</Descriptions.Item>
                  <Descriptions.Item span={3} label="备注">{info.comment}</Descriptions.Item>
                </Descriptions>}
              </Panel>
              <Panel header="需求描述" key="4">
                <div className={styles.questions}>
                  {
                    questionTags.map(_ => <Tag color="#1890FF" key={_}>{_}</Tag>)
                  }
                </div>
                <Descriptions>
                  <Descriptions.Item span={3} label="所属中心">{['--', '儿童心理', '青少年心理', '人际职场+个人成长', '恋爱婚姻', '情绪睡眠+心理疾病', '不确定'][info.attachCenter]}</Descriptions.Item>
                  <Descriptions.Item span={3} label="问题类型">{info.questionTypeTwo}</Descriptions.Item>
                  <Descriptions.Item span={3} label="核心诉求描述">{info.coreRequirement}</Descriptions.Item>
                  <Descriptions.Item span={3} label="其他">{info.otherQuestion}</Descriptions.Item>
                </Descriptions>
              </Panel>
              <Panel header="家庭信息" key="2">
                {/* { info.customerFamilies &&
                <Descriptions>
                <Descriptions.Item label="父亲">{info.fatherName}</Descriptions.Item>
                <Descriptions.Item label="年龄">{info.fatherAge}</Descriptions.Item>
                <Descriptions.Item label="职业">{info.fatherOccupation}</Descriptions.Item>
                <Descriptions.Item label="母亲">{info.motherName}</Descriptions.Item>
                <Descriptions.Item label="年龄">{info.motherAge}</Descriptions.Item>
                <Descriptions.Item label="职业">{info.motherOccupation}</Descriptions.Item>
                <Descriptions.Item span={3} label="家庭地址">{info.motherPhone}</Descriptions.Item>
                <Descriptions.Item label="紧急联系人">{info.contactName}</Descriptions.Item>
                <Descriptions.Item label="关系">{info.relation}</Descriptions.Item>
                <Descriptions.Item label="联系电话">{info.contactPhone}</Descriptions.Item>
              </Descriptions>
              } */}
                {info.customerFamilies &&
                  <Table
                    size="small"
                    bordered={false}
                    columns={familyColumns}
                    dataSource={info.customerFamilies}
                    pagination={false}
                  />
                }
              </Panel>
              {/* <Panel header="服务成员" key="3">
              <Descriptions>
                <Descriptions.Item label="就诊医院">{info.hospitalName}</Descriptions.Item>
                <Descriptions.Item label="在线医助">{info.assistantDoctorName}</Descriptions.Item>
                <Descriptions.Item label="心理顾问">{info.consultantDoctorName}</Descriptions.Item>
                <Descriptions.Item label="私人管家">{info.personalDoctorName}</Descriptions.Item>
                <Descriptions.Item label="主治医生">{info.residentDoctorName}</Descriptions.Item>
              </Descriptions>
            </Panel> */}
            </Collapse>
          </Spin>
        </TabPane>
        {/* <TabPane tab='健康档案' key=''>
          <HealthyDoc info={info} />
        </TabPane> */}
        {/* <TabPane tab="诊疗档案" key="treatment">
          <div className={styles.treatment}>
            <div className='treatment-checkableTag'>
              <CheckableTag onChange={e => handleCheckAleTag({ value: 'first_visit_bps_record_sheet' })} checked={'first_visit_bps_record_sheet' === treatmentTypes}>首咨BPS</CheckableTag>
              {treatment && treatment.map(_ => { if (_.value !== 'first_visit_bps_record_sheet') { return <CheckableTag onChange={e => handleCheckAleTag(_)} checked={_.value === treatmentTypes}>{(CUSTOMER_SERVICE_TYPE.find(item => item.value === _.value) || {}).label}</CheckableTag> } })}
              {
                info.reservationItemId &&
                <div style={{ marginTop: 5 }}>
                  <a style={{ color: 'green' }} target='_blank' href={`/task/${info.reservationItemId}/bsp-visit`}>前往编辑首咨BPS</a>
                </div>
              }
            </div>
            <Spin spinning={!!loading.effects['personalPotentialList/queryCustomerHistory']}>
              <Table
                columns={treatmentColumns}
                dataSource={arrReverse(customerHistoryList)}
                pagination={{ ...customerHistoryPagination }}
                size='small'
                onChange={(pagination, filter, sorter) => handleTrePagination(pagination)}
              />
            </Spin>
          </div>
        </TabPane> */}
         {/* {
          roleShowTreatment(currentRole, myName) &&
          <TabPane tab="诊疗档案" key="treatment">
            <div className={styles.treatment}>
              <div className='treatment-checkableTag'>
                {
                  fiveTypeHistory && fiveTypeHistory.map(it => {
                    return <CheckableTag
                      onChange={() => setTreatmentTypes(it.key)}
                      checked={treatmentTypes ? it.key == treatmentTypes : SafeGet(fiveTypeHistory, '0.key') == it.key}
                    >
                      {it.key}
                    </CheckableTag>
                  })
                }
                <span style={{ float: 'right', marginLeft: 20, lineHeight: '22px' }}>心理师:{psychologyList.length > 0 ? psychologyList.map(i => i.nickname).join(',') : '暂无'}</span>
                <span style={{ float: 'right', marginLeft: 20, lineHeight: '22px' }}>顾问:{consultant.nickname}</span>
                {
                  !isEmpty(fiveTypeHistory) &&
                  <LongShowExcelModal
                    renderBtn={<div style={{ height: 34 }}><div type='primary' size='small' className={styles.checkAllReport}>查看所有报告</div></div>}
                    records={treatmentTypes ? SafeGet(fiveTypeHistory.filter(i => i.key == treatmentTypes), '0.list', []) : SafeGet(fiveTypeHistory, '0.list', [])}
                    taskDetail={{ customerName: info.name }}
                  />
                }
              </div>
              <Spin spinning={!!loading.effects['personalPotentialList/queryFiveTypeHistoryList']}>
                <Table
                  columns={newTreatmentColumns}
                  dataSource={treatmentTypes ? SafeGet(fiveTypeHistory.filter(i => i.key == treatmentTypes), '0.list', []) : SafeGet(fiveTypeHistory, '0.list', [])}
                  pagination={false}
                  size='small'
                />
              </Spin>
            </div>
          </TabPane>
        } */}
        {
          roleShowTreatment(currentRole, myName) &&
          <TabPane tab="诊疗档案" key="treatment">
            <div className={styles.treatment}>
              <div className='treatment-checkableTag'>
                {
                  fiveTypeHistory && fiveTypeHistory.map(it => {
                    const isSelected = treatmentTypes
                      ? it.key === treatmentTypes
                      : SafeGet(fiveTypeHistory, '0.key') === it.key;

                    return (
                      <CheckableTag
                        key={it.key}
                        onChange={() => setTreatmentTypes(it.key)}
                        checked={isSelected}
                      >
                        {it.key}
                      </CheckableTag>
                    );
                  })
                }
                {/* 心理师和顾问仅在 key !== '测评报告' 时显示 */}
                {treatmentTypes !== '测评报告' && (
                  <>
                    <span style={{ float: 'right', marginLeft: 20, lineHeight: '22px' }}>
                      心理师: {psychologyList.length > 0 ? psychologyList.map(i => i.nickname).join(',') : '暂无'}
                    </span>
                    <span style={{ float: 'right', marginLeft: 20, lineHeight: '22px' }}>
                      顾问: {consultant.nickname}
                    </span>
                  </>
                )}
                {/* 查看所有报告按钮仅在 key !== '测评报告' 时显示 */}
                {treatmentTypes !== '测评报告' && !isEmpty(fiveTypeHistory) && (
                  <LongShowExcelModal
                    renderBtn={
                      <div style={{ height: 34 }}>
                        <div type='primary' size='small' className={styles.checkAllReport}>
                          查看所有报告
                        </div>
                      </div>
                    }
                    records={
                      treatmentTypes
                        ? SafeGet(fiveTypeHistory.filter(i => i.key === treatmentTypes), '0.list', [])
                        : SafeGet(fiveTypeHistory, '0.list', [])
                    }
                    taskDetail={{ customerName: info.name }}
                  />
                )}
              </div>
              {/* 表格内容 */}
              <Spin spinning={!!loading.effects['personalPotentialList/queryFiveTypeHistoryList']}>
                <Table
                  columns={newTreatmentColumns}
                  dataSource={
                    treatmentTypes
                      ? SafeGet(fiveTypeHistory.filter(i => i.key === treatmentTypes), '0.list', [])
                      : SafeGet(fiveTypeHistory, '0.list', [])
                  }
                  pagination={false}
                  size='small'
                />
              </Spin>
            </div>
          </TabPane>
        }

        {/* <TabPane tab="需求分析" key="demand">
          <Spin spinning={!!loading.effects['personalPotentialList/queryDemand']}>
            <DemandList data={arrReverse(demand)} />
          </Spin>
        </TabPane> */}
        <TabPane tab="跟进信息" key="follow">
          <Spin spinning={!!loading.effects['personalPotentialList/queryFollow']}>
            <FollowList
              data={arrReverse(follow)}
              onEdit={(data) => {
                onAction('follow', 'update', {
                  id: data.id,
                  customerId: info.customerId,
                  customerName: info.name,
                  type: data.type,
                  typeName: data.typeName,
                  content: data.content,
                  comment: data.comment
                })
              }}

            />
          </Spin>
        </TabPane>
        <TabPane tab="预约信息" key="reserve">
          <Spin spinning={!!loading.effects['personalPotentialList/queryReserve']}>
            {reserve && <ReserveList
              data={reserve}
              reserveStatus={reserveStatus}
              onEdit={(data) => {
                onAction('orderReserve', 'update', {
                  ...data,
                  id: data.id,
                  customerId: info.customerId,
                  customerName: info.name,
                })
              }}
              onEditStatus={(data, customerId) => {
                onEditStatus('updateReservationStatus', data, customerId)
              }}
              onAddReserveFollow={(data) => {
                onAction('follow', 'add', {
                  customerId: info.customerId,
                  customerName: info.name,
                  ...data
                })
              }}
            />}
          </Spin>
        </TabPane>
        <TabPane tab="订单信息" key="order">
          <Spin spinning={!!loading.effects['personalPotentialList/queryOrder']}>
            <OrderList data={order}
              pagination={orderPagination}
              onEdit={(data) => {
                onAction('order', 'update', {
                  ...data,
                  id: data.id,
                  customerId: info.customerId,
                  customerName: info.name,
                })
              }}
              onChange={pageNo => onOrderPageNoChange(info.customerId, pageNo)}
              deleteOrder={(data) => deleteOrder(data)}
              cancelOrder={(id, customerId) => cancelOrder(id, customerId)}
            />
          </Spin>
        </TabPane>
        {/* <TabPane tab="修改记录" key="modify">
          <Spin spinning={!!loading.effects['personalPotentialList/queryModify']}>
            <ModifyList data={modify} info={infoInit} />
          </Spin>
        </TabPane> */}
        <TabPane tab="数据统计" key="statistics">
          <Statistics
            info={info}
            loading={loading}
            statistics={statistics}
            executorList={executorList}
            statisticsPagination={statisticsPagination}
            statisticsOnChange={(pagination, type) => statisticsOnChange(pagination, type, info.customerId)}
          />
        </TabPane>
      </Tabs>
      <Modal title='问卷二维码' width={300} visible={qestionnaireVisible} footer={null} mask={false} onCancel={() => setQestionnaireVisible(false)}>
        <QRCode
          value={qestionnaireUrl}  //value参数为生成二维码的链接
          size={200} //二维码的宽高尺寸
          // fgColor="#000000"
          style={{ margin: '0 auto' }}
        />
      </Modal>
      {
        showCodeModal &&
        <EditCustomerCode
          customerId={info.customerId}
          closeModal={() => setShowCodeModal(false)}
          visible={showCodeModal}
        />
      }
    </Drawer>
  )
}

export default PersonalDrawer
